/* istanbul ignore file */
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
//import { configureStore } from '@reduxjs/toolkit'

import axios from 'axios';
import * as _ from 'lodash';
import log4javascript from 'log4javascript';
import Q from 'q';
import { BLUEXP_CONFIG } from './Auth/bluexp-variables';
import Auth from './Auth/Auth';
import CigApp from './framework/CigApp';
import reducers from './reducers';
import { CIG_PROD_MOD, AUTH0 } from './common/constants';
import { redirectToNetAppConsoleHome, shouldRedirectToNetAppConsole } from './common/utils';
import * as serviceWorker from './registerServiceWorker';

let CIG = {};
let App = {};
let store = {};
window.log4javascript = log4javascript;

function getConfig() {
    let deferred = Q.defer();
    CIG['prod'] = false;

    axios
        .get('/rest/v1/systemInfo')
        .then((res) => {
            CIG['mode'] = res.data.mode || 'PROD';
            CIG['prod'] = _.includes(CIG_PROD_MOD, res.data.mode);
            CIG['swEnabled'] = _.get(res.data, 'swEnabled');
            CIG['authProvider'] = _.get(res.data, 'authProvider', AUTH0);
            CIG['serverTimeUTC'] = _.get(res.data, 'serverTimeUTC', 0);
            CIG['standaloneMode'] = _.get(res.data, 'standaloneUiMode', false);
            CIG['productType'] = _.get(res.data, 'productType');
            CIG['netAppConsoleUrl'] = _.get(res.data, 'netAppConsoleUrl', undefined);
            window.CIG = CIG;
            deferred.resolve(res.data);
        })
        .catch(function(err) {
            let msg = `Error fetching system info data. ${err}`;
            deferred.reject(msg);
        });

    return deferred.promise;
}

function initLog() {
    let deferred = Q.defer();
    const CIG_LOG = log4javascript.getRootLogger();
    const isUsePopupLogger = false;  //turn on manually
    let logAppender;
    if (isUsePopupLogger) {
        logAppender = new log4javascript.PopUpAppender();
    }
    else {
        logAppender = new log4javascript.BrowserConsoleAppender();
    }
    // let logLayout = new log4javascript.PatternLayout('%d{HH:mm:ss} %-5p - %m');
    const logLayout = new log4javascript.PatternLayout('%d{ISO8601} %-5p - %m');
    logAppender.setLayout(logLayout);
    CIG_LOG.addAppender(logAppender);

    const defaultLogLevel = (process.env.NODE_ENV === 'development') ? log4javascript.Level.DEBUG : log4javascript.Level.INFO;
    CIG_LOG.setLevel(defaultLogLevel);
    window.CIG_LOG = CIG_LOG;
    deferred.resolve();
    return deferred.promise;
}

function initAuthParams() {
    let deferred = Q.defer();
    if (CIG.authProvider === AUTH0) {
        CIG['blueXPConfig'] = {
            ...BLUEXP_CONFIG[CIG.mode],
            'serviceUrl': CIG['netAppConsoleUrl'] || BLUEXP_CONFIG[CIG.mode].serviceUrl,
        };
        window.auth = new Auth();
    }
    window.CIG_LOG.debug('Gateway: init......');
    deferred.resolve();
    return deferred.promise;
}

function startApp() {
    let deferred = Q.defer();
    window.CIG_LOG.debug('Gateway: Start APP.....');
    App = () => (
        <CigApp />
    );
    App.displayName = 'App';

    store = createStore(
        reducers,
        {},
        applyMiddleware(reduxThunk)
    );

    // store = configureStore({
    //     reducers,
    //     middleware: [reduxThunk],
    //     preloadedState: {},
    // });

    const root = ReactDOM.createRoot(document.querySelector('#root'));
    root.render(<Provider store={store}><App /></Provider>);

    window.App = App;
    window.App.log = window.CIG_LOG;
    window.CIG.store = store;
    deferred.resolve();
    return deferred.promise;
}

function setupServiceWorker() {
    let deferred = Q.defer();
    if (CIG.swEnabled === true) {
        serviceWorker.register();
        window.CIG_LOG.debug('Gateway: Register service worker');
    } 
    else {
        serviceWorker.unregister();
    }
    deferred.resolve();
    return deferred.promise;
}

Q.when(getConfig())
    .then(function() { return initLog(); })
    .then(function() {return setupServiceWorker();})
    .then(function() { return initAuthParams(); })
    .then(function() {
        if (shouldRedirectToNetAppConsole()) {
            if (redirectToNetAppConsoleHome()) {
                return Q.defer().promise;
            }
            window.CIG_LOG.warn('Gateway: standalone UI disabled but netAppConsoleUrl is missing; continuing app bootstrap.');
        }
        return startApp();
    })
    .catch(function(err) {
        window.CIG_LOG.error(`Gateway: Failed to start app. ${err}`);
    });
